var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-count-down-digit"},[_c('div',{style:({ transform: ("translateY(" + (-_vm.digit) + "em)") })},_vm._l((10),function(i){return _c('span',{key:i},[_vm._v(_vm._s(i - 1))])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }